import { ScreeningViewTemplate } from '../ScreeningTemplate'
import { useTranslation } from 'react-i18next'

export const ScreeningStandardPending = () => {
  const { t } = useTranslation()
  return (
    <ScreeningViewTemplate
      pageTitle={t('employee.screening.standardCompletedPending')}
      screeningTitle={t('employee.screening.standardCompletedPending')}
      screeningDescription={t('employee.screening.standardPendingDescription')}
      hideButton
    />
  )
}
